<div class="event-wrapper">
  <div class="event-container item">
    <evrideo-calendar-expandable-red-line-indicator
      [redLineVisible]="properties.redLineVisible"
    ></evrideo-calendar-expandable-red-line-indicator>
    <div
      class="visibility-icon"
      (click)="toggleSecEvent(show, properties.id)"
      [inlineSVG]="
        properties.enabled
          ? '../../assets/icons/eye-icon.svg'
          : '../../assets/icons/eye-disabled.svg'
      "
    ></div>
    <evrideo-calendar-expandable-progress-bar
      [eventData]="properties"
      class="progress-bar"
    ></evrideo-calendar-expandable-progress-bar>
    <div class="in-front">
      <div class="item-title-container">
        <div
          class="event-icon"
          inlineSVG="../../assets/icons/graphics.svg "
        ></div>
        <span class="item-title-text">Graphics</span>
      </div>
      <div class="item-name">{{ properties.name }}</div>
      <div class="item-text-overrides" [title]="textOverrides">
        <span class="text">{{ textOverrides }}</span>
      </div>
      <div class="start-time-container">
        <evrideo-calendar-expandable-editable-time
          [eventData]="graphicsData"
          [showId]="show.id"
          [timeType]="'StartTime'"
          [time]="formatTime(properties.startTime)"
          [editLocked]="true"
          [eventData]="graphicsData"
        ></evrideo-calendar-expandable-editable-time>
      </div>
      <div class="end-time-container">
        <evrideo-calendar-expandable-editable-time
          [eventData]="graphicsData"
          [showId]="show.id"
          [timeType]="'EndTime'"
          [time]="formatTime(properties.endTime)"
          [editLocked]="true"
        ></evrideo-calendar-expandable-editable-time>
      </div>
      <div class="duration-time-container">
        <evrideo-calendar-expandable-editable-time
          [eventData]="graphicsData"
          [showId]="show.id"
          [timeType]="'Duration'"
          [time]="formatDuration(properties.duration)"
          [editLocked]="true"
        ></evrideo-calendar-expandable-editable-time>
      </div>
      <div class="offset-time-container">
        <evrideo-calendar-expandable-editable-time
          [eventData]="graphicsData"
          [showId]="show.id"
          [timeType]="'Offset'"
          [time]="formatDuration(properties.offset)"
          [editLocked]="true"
        ></evrideo-calendar-expandable-editable-time>
      </div>
      <div class="right-items">
        <a
          class="edit-item"
          href="/scheduler/graphics/edit/{{ properties.instanceId }}"
          >Instance</a
        >
        <!--                <div (click)="deleteEvent()" class="trash-icon" inlineSVG="../../assets/icons/trash-enabled.svg "></div>-->
      </div>
    </div>
  </div>
</div>
